import { useStartProcess } from "@/hooks/ai-tool-process/use-start-process";
import { vocalRemoverSessionStorage } from "@/services/storage/vocal-remover-session-storage";
import { useVocalRemoverProgressContext } from "@/components/pages/vocal-remover/providers/vocal-remover-progress-provider";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { LicenseName } from "@/data/license.data";

export type VocalRemoverConfig = {
  songFile: File | null;
};

const startVocalRemoverConfigCreator = (
  vocalRemoverConfig: VocalRemoverConfig,
) => {
  return {
    createConfigFormData: (formData: FormData) => {
      formData.append("songFile", vocalRemoverConfig.songFile as Blob);
    },
  };
};

export const useStartVocalRemover = () => {
  const progressContext = useVocalRemoverProgressContext();
  const { showModal } = useGlobalModalContext();
  const showLimitedModal = (licenseName: LicenseName) =>
    showModal({
      type: "vocal-remover-count-limited_modal",
      props: {
        licenseName: licenseName,
      },
    });

  const { startAiProcess } = useStartProcess(
    (config: VocalRemoverConfig) => startVocalRemoverConfigCreator(config),
    vocalRemoverSessionStorage.pendingConfigStorage,
    "/api/vocal-remove/file",
    progressContext,
    showLimitedModal,
  );

  return { startVocalRemove: startAiProcess };
};
